import { JsonObject } from "json2typescript";
import { PortfolioanalysisTradesInterface } from "../interfaces/portfolioanalysis-trades.interface";

@JsonObject("PortfolioanalysisTrades")
export class PortfolioanalysisTrades implements PortfolioanalysisTradesInterface {
    Amount?: number;
    Code?: string;
    Commisions?: number;
    ContractCode?: string;
    Currency?: string;
    ExhangeRate?: number;
    Id?: string;
    Isin?: string;
    NumberOfShares?: number;
    PriceCurrency?: string;
    ProductCode?: string;
    ProductName?: string;
    QuotationType?: string;
    TaxRegimeName?: any;
    TradeCode?: string;
    TradeDate?: string;
    TradeName?: string;
    TradeNumber?: string;
    TradePrice?: number;
    ValueDate?: string;
    Withholdings?: number;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}
